import React from "react";

const Hero = () => {
    return (
        <section className="w-full container mx-auto px-6 md:px-12 lg:px-20 pt-28 lg:pt-40 pb-14 lg:pb-24">
            <div className="max-w-4xl flex flex-col gap-6 text-left">
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-normal leading-tight md:leading-tight lg:leading-tight text-blue10 pointer-events-none">
                    Fractional partners,<br />
                    <span className="font-light italic text-primaryBrand">shaped around</span> your work.
                </h1>
                <p className="text-base md:text-lg lg:text-xl leading-normal text-blue70 max-w-3xl pointer-events-none">
                    Add capacity when things get busy, pull back when they slow down, and always have practitioners in your corner who care about your business as much as you do.

                </p>
            </div>
        </section>
    );
};

export default Hero;
